import React from 'react';
import Hidden from '../../Hidden';
import Backdrop from '../../Backdrop';

const ResponsiveBackdrop = /*#__PURE__*/function () {
  const ResponsiveBackdrop = function ResponsiveBackdrop(_ref) {
    var onClick = _ref.onClick,
        zIndex = _ref.zIndex;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Backdrop, {
      zIndex: zIndex,
      invisible: true,
      onClick: onClick
    }), /*#__PURE__*/React.createElement(Hidden, {
      above: "sm"
    }, /*#__PURE__*/React.createElement(Backdrop, {
      zIndex: zIndex,
      onClick: onClick
    })));
  };

  ResponsiveBackdrop.defaultProps = {
    zIndex: 700
  };
  return ResponsiveBackdrop;
}();

export default ResponsiveBackdrop;